import PropTypes from 'prop-types';

import { Card, Layout } from '@utilities';

import { answerOperators } from '../../../../../QuestionLogic/utilities/constants';
import QuestionLogicOptions from '../../../../../QuestionLogic/components/QuestionLogicOptions';
import SkipLogicRow from '../../../../../QuestionLogic/components/SkipLogicRow';

const QuestionLogicCondition = ({
  question,
  questionBeingMoved,
  questionLogic,
  selectedQuestions,
  type,
}) => {
  const logicList = questionLogic?.[question.id]?.skip?.logic || [];
  // only show skip logic that references questions below the current question
  const skipLogicIndexes = logicList.reduce((acc, logicItem, index) => {
    if (!selectedQuestions || !question) return acc;

    const currentQuestionIndex = selectedQuestions.findIndex(({ id }) => id === question.id);
    const logicQuestionId = logicItem?.question?.id;
    const logicQuestionIndex = selectedQuestions.findIndex(({ id }) => id === logicQuestionId);
    if (logicQuestionIndex > currentQuestionIndex) acc.push(index);
    return acc;
  }, []);

  return (
    <Card>
      <h4>Condition</h4>
      <Layout.Flex.Column gap="small">
        {type === 'disqualify' && (
          <div>
            <span>Disqualify if the answer is&nbsp;</span>
            <QuestionLogicOptions
              isCompleted={true}
              options={answerOperators}
              optionsType="radio"
              value={questionLogic[question.id].disqualify.operator}
            />
            <span>:&nbsp;</span>
            <QuestionLogicOptions
              isCompleted={true}
              options={question.answers}
              optionsLabel="Answer Options"
              optionsType="checkbox"
              value={questionLogic[question.id].disqualify.answers}
            />
          </div>
        )}
        {skipLogicIndexes.map((index) => (
          <SkipLogicRow
            index={index}
            isCompleted
            key={index}
            questionId={question.id}
            questionList={selectedQuestions}
            questionLogic={questionLogic}
          />
        ))}
      </Layout.Flex.Column>
    </Card>
  );
};

QuestionLogicCondition.propTypes = {
  question: PropTypes.object.isRequired,
  questionBeingMoved: PropTypes.object,
  questionLogic: PropTypes.object.isRequired,
  selectedQuestions: PropTypes.array,
  type: PropTypes.oneOf(['disqualify', 'skip']).isRequired,
};

export default QuestionLogicCondition;
